import { render, staticRenderFns } from "./DemoErrorTools.vue?vue&type=template&id=490822aa&scoped=true&"
import script from "./DemoErrorTools.vue?vue&type=script&lang=js&"
export * from "./DemoErrorTools.vue?vue&type=script&lang=js&"
import style0 from "./DemoErrorTools.vue?vue&type=style&index=0&id=490822aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490822aa",
  null
  
)

export default component.exports